<template>
  <div class="main-container">
    <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />

    <tl-header class="title" type="h3">Configure Events</tl-header>
    <div class="header header3 title">
      <span class="text">Birthday</span>
    </div>
    <span class="input-label">Birthdays visible to</span>
    <div class="radio">
      <tl-radio name="birthday" label="Legal Entity" id="birthday1" value="Legal Entity" v-model="bithdayObj.visible" />
      <tl-radio
        name="birthday"
        label="Paygroup"
        id="birthday2"
        value="Paygroup"
        v-model="bithdayObj.visible"
      />
      <tl-radio
        name="birthday"
        label="Department"
        id="birthday3"
        value="Department"
        v-model="bithdayObj.visible"
      />
      <tl-radio
        name="birthday"
        label="Only to the employee"
        id="birthday4"
        value="SELF"
        v-model="bithdayObj.visible"
      />
    </div>
    <txt class="custom-width" type="textarea" label="Write custom message" v-model="bithdayObj.message" rows="4" />

    <div class="header header3 title">
      <span class="text">Work Anniversary</span>
    </div>
    <tl-checkbox
      label="Recalculate Work Anniversary on transfer within organisation"
      v-model="recalculateWA"
    />
    <div class="space">Work Anniversary visible to</div>
    <div class="radio">
      <tl-radio
        name="workAnniversary"
        label="Legal_Entity"
        id="workAnniversary1"
        value="Legal_Entity"
        v-model="workanniversaryObj.visible"
      />
      <tl-radio name="workAnniversary" label="Paygroup" id="workAnniversary2" value="Paygroup" v-model="workanniversaryObj.visible" />
      <tl-radio
        name="workAnniversary"
        label="Department"
        id="workAnniversary3"
        value="Department"
        v-model="workanniversaryObj.visible"
      />
      <tl-radio
        name="workAnniversary"
        label="Only to the employee"
        id="workAnniversary4"
        value="SELF"
        v-model="workanniversaryObj.visible"
      />
    </div>
    <txt class="custom-width" type="textarea" label="Write custom message" v-model="workanniversaryObj.message" rows="4" />
    <div class="header header3 title">
      <span class="text">Marriage Anniversary</span>
    </div>
    <span class="input-label">Marriage Anniversary visible to</span>
    <div class="radio">
      <tl-radio
        name="MAnniv"
        label="Legal_Entity"
        id="MAnniv1"
        value="Legal_Entity"
        v-model="marriageAnniversaryObj.visible"
      />
      <tl-radio name="MAnniv" label="Paygroup" id="MAnniv2" value="Paygroup" v-model="marriageAnniversaryObj.visible" />
      <tl-radio
        name="MAnniv"
        label="Department"
        id="MAnniv3"
        value="Department"
        v-model="marriageAnniversaryObj.visible"
      />
      <tl-radio
        name="MAnniv"
        label="Only to the employee"
        id="MAnniv4"
        value="SELF"
        v-model="marriageAnniversaryObj.visible"
      />
    </div>
    <txt class="custom-width" type="textarea" label="Write custom message" v-model="marriageAnniversaryObj.message" rows="4" />
    <pop-up-message
      v-if="showSuccessMsg"
      message="Events configured!"
      btnText="Back to Configure events"
      @back="()=>showSuccessMsg=false"
    />
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="routeToSubStep" />
          <btn text="Save" type="primary" @click="save" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "Configure Events",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/events`
              }
        ],
      birthday: "",
      WAAnniv: "",
      MAnniv: "",
      le_id: "4a3d1e49-6cac-468d-a297-0e5b35a208ce",
      recalculateWA: false,
      bithdayObj:{
        type:'BIRTHDAY',
        visible:'',
        message:''
      },
      workanniversaryObj:{
        type:'MARRIAGE ANNIVERSARY',
        visible:'',
        message:''
      },
      marriageAnniversaryObj:{
        type:'WORK ANNIVERSARY',
        visible:'',
        message:''
      },
      showSuccessMsg: false
    };
  },
  methods: {
    ...mapActions({
      act_create: "dashboard/organisation/utilities/eventconfigure/create",
    }),
    routeToSubStep() {
      this.$router.push({ path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities` });
    },
    routeToMainStep() {
      this.$router.push({ path: `/dashboard/${this.$route.params.entity_index}/organisation`});
    },

    async performAction() {
      let configArray = [];
      configArray.push(this.bithdayObj,this.workanniversaryObj,this.marriageAnniversaryObj);

      let requestObj = {
        le_id:'4a3d1e49-6cac-468d-a297-0e5b35a208ce',
        config:[...configArray]
      };
      try {
        this.$root._data.isSaving = true;
        await this.act_create({
          data: requestObj
        });
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
        this.refresh();
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    refresh(){

    },

    async save() {
      //console.log("formData");
      this.$validator.validateAll().then(result => {
        if (result) {
          //console.log("perform signup", result);
          this.performAction().then(() => {
            this.showSuccessMsg = true;
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  padding-top: 36px;
}
.radio {
  display: flex;
  padding-top: 10px;
}
.custom-width {
  padding-top: 37px;
  width: 427px;
}
.space {
  margin-top: 20px;
  bottom: 0;
  font-size: 12px;
  font-weight: 400;
  color: #6e6e6e;
}
</style>
